function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect } from 'react';
import { useMutationObserver } from "./use-mutation-observer.js";

/**
 * React hook for detecting if `dir="rtl"` is present on an `HTMLElement` or `ref`.
 * Defaults to `<html>` element as `node`.
 * @params UseRtlOptions
 * @returns UseRtlState
 */
var useRtl = function useRtl() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ref = options.ref,
    _options$node = options.node,
    node = _options$node === void 0 ? ref ? undefined : document.querySelectorAll('html')[0] : _options$node;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRtl = _useState2[0],
    setIsRtl = _useState2[1];
  useMutationObserver({
    callback: function callback(mutations) {
      var _iterator = _createForOfIteratorHelper(mutations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          var attributeName = mutation.attributeName,
            target = mutation.target,
            type = mutation.type;
          if (attributeName === 'dir' && type === 'attributes') {
            setIsRtl(target.dir === 'rtl' ? true : false);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    mutationObserverOptions: {
      attributes: true
    },
    node: ref ? undefined : node,
    ref: ref
  });
  useEffect(function () {
    if (node) {
      setIsRtl(node.dir === 'rtl');
    }
  }, [node]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (ref !== null && ref !== void 0 && ref.current) {
      setIsRtl((ref === null || ref === void 0 ? void 0 : ref.current.dir) === 'rtl');
    }
  }, [ref === null || ref === void 0 ? void 0 : ref.current]); // eslint-disable-line react-hooks/exhaustive-deps
  return {
    dir: isRtl ? 'rtl' : 'ltr',
    isRtl: isRtl
  };
};
export { useRtl };